'use client'

import {
  useGlobalInboxSocket,
} from '@/contexts/InboxSocketContext'

export type RealtimeMessage = {
  conversationId: number
  messageId: number | null
  senderId: number
  body: string
  dateAdded: string
  clientId?: string | null
}

export type RealtimeTyping = {
  conversationId: number
  userId: number
  isTyping: boolean
}

export type RealtimeRead = {
  conversationId: number
  userId: number
  messageId: number
}

export function useInboxSocket(
  _userId?: number | null
) {
  return useGlobalInboxSocket()
}